import script from "./AddRecordedVideosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRecordedVideosModal.vue?vue&type=script&setup=true&lang=js"

import "./AddRecordedVideosModal.vue?vue&type=style&index=0&id=c92e90d2&lang=css"

const __exports__ = script;

export default __exports__